import React, { useRef, useState, useEffect } from 'react'
import Image from '../Image'
const Number = ({ props, label, error, errorText, changeFn, defaultValue, placeholder,
    digit, numDigit, min, max, type}) => {
    const inputRef = useRef()
    const [Error, setError] = useState(null)
    useEffect(() => {
        let value = defaultValue
        if(type=== "floor" && defaultValue <= 0 ) value=`B${(defaultValue-1)*-1}`
        inputRef.current.value = value
    }, [defaultValue])
    const action = (type) => {
        let value = defaultValue? defaultValue*1  :  0
        let final = value
        if(type==='add'){
            if(max && value>=max){

            }else{
                final = numDigit?(value+digit).toFixed(numDigit):(value+digit)
            }
        }else{
            if( min!=='undefined' && value <= min){
                final = numDigit? value.toFixed(numDigit):value
            }else{
                final =  numDigit?(value-digit).toFixed(numDigit):(value-digit)
            }
        }
        changeFn(final)
    }
    return (
        <div className={`input-container ${Error || error ? 'input-container-error' : ''}`}>
            {label && <label>{label}</label>}
            <div className='input-block'>
                <input
                    className={`input-number`}
                    readOnly
                    ref={inputRef}
                    placeholder={placeholder}
                    {...props} />
                {
                    (Error || errorText) && (<p className='error'>{Error || errorText}</p>)
                }
                <div className='btn-group'>
                    <div className='btn-text' onClick={() => action('substract')}>
                        <Image src='/images/icons/minus.svg' />
                    </div>
                    <div className='btn-text' onClick={() => action('add')}>
                        <Image src='/images/icons/plus.svg' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Number